<template>
  <div class="activityDetailsPage">
    <van-loading v-if="loading"
                 type="spinner"
                 color="#F0D19E"
                 vertical>加载中...</van-loading>
    <div v-if="!loading"
         class="content">
      <!-- <div class="heard_box">
        <div class="heard_left">
          <img :src="userInfo.avatarUrl"
               alt="">
          <span>{{userInfo.nickName}}</span>
        </div>
        <div class="heard_right"
             @click="handleViewRule">活动规则></div>
      </div> -->
      <img class="activity_bg"
           src="../../sprite/activity_bg.png"
           alt="">
      <img class="activity_rule"
           src="../../sprite/activity_rule.png"
           alt=""
           @click="handleViewRule">
      <p class="activity_time">活动时间：{{activityInfo.startTime}}~{{activityInfo.endTime}}</p>
      <div class="main_body_box">
        <div class="product_box">
          <img class="title_icon"
               src="../../sprite/hot_product_title.png"
               alt="">
          <ul>
            <li v-for="(item, index) in productList"
                :key="index"
                @click="shareHandle(item)">
              <img class="item_img"
                   :src="item.productImage"
                   alt="">
              <p class="title">{{item.productName}}</p>
              <div class="money">
                <div class="price">
                  <span>{{item.salePrice || 0}}</span><span>元</span>
                </div>
                <div class="commision">佣金¥{{item.oneCommission || 0}}</div>
              </div>
              <div class="promote_now_btn">立即推广</div>
            </li>
          </ul>
          <div class="more_btn"
               @click="$router.push('/')">查看更多></div>
        </div>
        <div class="rank_box">
          <img class="rank_grad_bg"
               src="../../sprite/rank_grad_bg.png"
               alt="">
          <img class="title_icon"
               src="../../sprite/rank_title.png"
               alt="">
          <div class="top_three_box">
            <div class="second_box top_three_common_class">
              <img class="rank2"
                   src="../../sprite/rank2.png"
                   alt="">
              <img class="avatar_url"
                   :src="topThree[1] && topThree[1].avatarUrl"
                   alt="">
              <img class="icon_rank2"
                   src="../../sprite/icon_rank2.png"
                   alt="">
              <p class="user_nicker">{{topThree[1] && topThree[1].userNicker}}</p>
              <p class="commision"><span>{{topThree[1] && topThree[1].saleAmountShort}}<span v-if="topThree[1] && topThree[1].saleAmount>10000">万</span></span><span>元</span></p>
            </div>
            <div class="first_box top_three_common_class">
              <img class="rank1"
                   src="../../sprite/rank1.png"
                   alt="">
              <img class="avatar_url"
                   :src="topThree[0] && topThree[0].avatarUrl"
                   alt="">
              <img class="icon_rank1"
                   src="../../sprite/icon_rank1.png"
                   alt="">
              <p class="user_nicker">{{topThree[0] && topThree[0].userNicker}}</p>
              <p class="commision"><span>{{topThree[0] && topThree[0].saleAmountShort}}<span v-if="topThree[0] && topThree[0].saleAmount>10000">万</span></span><span>元</span></p>
            </div>
            <div class="third_box top_three_common_class">
              <img class="rank3"
                   src="../../sprite/rank3.png"
                   alt="">
              <img class="avatar_url"
                   :src="topThree[2] && topThree[2].avatarUrl"
                   alt="">
              <img class="icon_rank3"
                   src="../../sprite/icon_rank3.png"
                   alt="">
              <p class="user_nicker">{{topThree[2] && topThree[2].userNicker}}</p>
              <p class="commision"><span>{{topThree[2] && topThree[2].saleAmountShort}}<span v-if="topThree[2] && topThree[2].saleAmount>10000">万</span></span><span>元</span></p>
            </div>
          </div>
          <div class="no_rank_data"
               v-if="saleRanksList.length == 0">暂无佣金排行数据~</div>
          <div class="table_box">
            <div class="bodyIn">
              <div class="tableBody"
                   v-for="(item, index) in saleRanksList"
                   :key="index">
                <div class="userInfo">
                  <img class="headImg"
                       :src="item.avatarUrl"
                       alt="">
                  <span class="name">{{item.userNicker}}</span>
                  <span class="rankNum">{{item.saleRank}}</span>
                </div>
                <div v-if="item.saleAmount > 10000"
                     class="money">{{item.saleAmountShort}}万元</div>
                <div v-else
                     class="money">{{item.saleAmountShort}}元</div>
              </div>
            </div>
          </div>
        </div>
        <div class="bottomCode">
          <img class="bg"
               src="../../assets/img/codeImg.png"
               alt="">
          <img class="codeIn"
               src="../../assets/img/codePic.png"
               alt="">
        </div>
        <!-- 暂时隐藏 -->
        <div class="placard_box1"
             v-if="isActivityEnd && !isPublicityTimeEnd">
          <div class="tip">活动已结束</div>
          <div class="time">发奖公示时间：{{publicityStartDate}}</div>
        </div>
        <div class="placard_box2"
             v-if="isActivityEnd && isPublicityTimeEnd">
          <span class="left">活动已结束，点击查看发奖公示</span>
          <span class="right"
                @click="goAwardPlacard">去查看</span>
        </div>
      </div>
      <div class="fixed_box">
        <div class="fixed_left">
          <img :src="token ? userInfo.avatarUrl : require('../../sprite/no_login.png')"
               alt="">
          <div class="my_rank_info">
            <div class="my_ranking">我的排名：<span v-if="token && mySaleRank > 20">未入榜</span><span v-if="token && mySaleRank <= 20">{{mySaleRank}}</span><span v-if="!token">登录后可查看</span></div>
            <div class="my_commission">佣金：<span v-if="token">¥{{mySaleAmount}}</span><span v-if="!token">登录后可查看</span></div>
          </div>
        </div>
        <div class="fixed_right"
             v-if="!token"
             @click="goLogin">立即登录</div>
      </div>
      <Rule v-if="showRulePopup"
            :isPromoteRuleShow="showRulePopup"
            :activityInfo="activityInfo"
            @closeRulePopup="handleCloseRulePopup"></Rule>
      <div class="joinDialog"
           :class="isVisible ? 'showDialog' : 'hiddenDialog'">
        <div class="content">
          <div class="joinIn">
            <div class="title">
              <div>
                <img src="https://fulu-tuike.oss-cn-hangzhou.aliyuncs.com/picture/d82109a544e04d9f8c66b50ca7a4604b.png"
                     alt="">
                <span>1.加入M-CLUB</span>
              </div>
              <span class="arr"></span>
              <div>
                <img src="https://fulu-tuike.oss-cn-hangzhou.aliyuncs.com/picture/647fe0c3922a4d499805f06f7ebed93c.png"
                     alt="">
                <span>2.分享售卡</span>
              </div>
              <span class="arr"></span>
              <div>
                <img src="https://fulu-tuike.oss-cn-hangzhou.aliyuncs.com/picture/2483fff2168f4fda8d9b2064da30175f.png"
                     alt="">
                <span>3.得返佣奖励</span>
              </div>
            </div>
            <div class="conter">
              <div class="user">
                <img :src="userInfo && userInfo.avatarUrl"
                     alt="">
                <span>{{userInfo && userInfo.nickName}}</span>
              </div>
              <div class="tip">加入M-CLUB省心赚</div>
              <div class="enterBtn"
                   @click="createUserInfo">确认协议并成为推广大使</div>
              <div class="agreement">我已同意以下协议：<span @click="viewAgreement('/serveAgreement')">《芒果TV M-CLUB芒果推广大使服务协议》</span><span @click="viewAgreement('/commissionAgreement')">《芒果TV
                  M-CLUB芒果推广大使佣金与行为规则》</span></div>
            </div>
          </div>
          <div class="close">
            <van-icon size="34"
                      color="#ffffff"
                      name="close"
                      @click="isVisible = false" />
          </div>
        </div>
      </div>

      <!-- 商品海报 -->
      <ProductPoster v-if="showProductPopup"
                     :show="showProductPopup"
                     :shareProduct="shareProduct"
                     :userInfo="userInfo"
                     :activityInfo="activityInfo"
                     pageType="activity"
                     @closePopup="handleClose"></ProductPoster>
    </div>
  </div>
</template>
<script>
import {
  getToken,
  urlParse,
  isMangguoApp,
  MGTVVIP_page_view,
  MGTVVIP_click_event
} from '../../utils/tokenUtils'
import mgLoginInfo from '../../utils/mgLoginInfo'
import { CreateUserInfo } from '../../service/home'
import {
  GetDataTimeNow,
  GetActivityInfo,
  GetProductListByIds,
  GetUserCommissionRankListByTime
} from '../../service/activityDetails'
import Rule from './rule.vue'
import './index.less'
export default {
  components: { Rule },
  data() {
    return {
      // 线上的
      activityId: 10009, // 活动id
      ids: [22930917114148, 22730917113050], // 活动商品id
      // 测试的
      // activityId: 10009,
      // ids: [22320923144407, 22430902181821],

      publicityStartDate: '2022-10-08 12:00:00', // 发奖公示开始时间
      publicityEndDate: '2022-10-09 12:00:00', // 发奖公示结束时间

      loading: false,
      isApp: isMangguoApp(),
      token: '',
      userInfo: {},
      isOutIn: false,
      isDisable: false, // 账号是否被禁用
      isAuthorized: false, // 是否授权初始化用户信息
      isVisible: false, // 授权弹窗显隐
      mySaleRank: '', // 我的排名
      mySaleAmount: '', // 我的佣金
      activityInfo: {}, // 活动信息
      productList: [], // 商品list
      topThree: [], // 排名前三
      saleRanksList: [],

      nowTime: 0, // 当前时间时间戳（到秒 10位）
      endPublicityTime: 0, // 发奖公示时间戳
      isPublicityTimeEnd: false, // 是否到发奖公示时间
      isActivityEnd: false, // 活动是否已结束

      showRulePopup: false, // 活动规则 popup

      showProductPopup: false, // 商品海报显隐
      shareProduct: {} // 当前分享的商品对象信息
    }
  },
  computed: {},
  created() {
    this.endPublicityTime = new Date(
      this.publicityStartDate.replace(/-/g, '/')
    ).getTime()
    this.urlData = urlParse(window.location.href)
    // console.log(this.urlData, 'hhhh')
    this.loading = true
    this.getDataTimeNow()
  },
  mounted() {
    mgLoginInfo(this, 'activityDetails')
    setTimeout(() => {
      // 埋点，会员数据上报（页面PV）
      let mgUuid = this.token ? this.userInfo.mgUuid : ''
      MGTVVIP_page_view(
        `${this.activityInfo.startTime.slice(0, 3)}活动页`,
        mgUuid
      )
    }, 300)
  },
  methods: {
    async init() {
      await this.getActivityInfo()
      await this.getProductListByIds()
    },
    // 去登录
    goLogin() {
      const that = this
      if (isMangguoApp()) {
        MgtvApi.login(function (data) {
          if (data.code == 200) {
            mgLoginInfo(that, 'activityDetails')
          }
        })
      } else {
        window.location.href = `https://m.mgtv.com/login/?from=${
          process.env.NODE_ENV == 'development'
            ? encodeURIComponent(window.location.href)
            : encodeURIComponent(window.location.href)
        }`
      }
    },
    // 确认授权成为大使
    createUserInfo() {
      CreateUserInfo({
        token: localStorage.getItem('token'),
        channelCode: this.urlData.channelCode,
        superiorId: this.urlData.superiorId,
        shareId: this.urlData.shareId
      }).then((res) => {
        const { code, data } = res
        if (code == '0') {
          localStorage.setItem('nickName', data.nickName)
          localStorage.setItem('avatarUrl', data.avatarUrl)
          localStorage.setItem('channelCode', data.channelCode)
          localStorage.setItem('mgUuid', data.mgUuid)
          localStorage.setItem('id', data.id)
          localStorage.setItem('shareId', data.shareId)
          localStorage.setItem('superiorId', data.superiorId)
          localStorage.setItem('userLevel', data.userLevel)
          this.isVisible = false
          this.isAuthorized = true // 是否授权初始化用户信息
          this.$toast('加盟成功')
        }
      })
    },
    // 点击 活动规则
    handleViewRule() {
      // this.$refs.refRule.isPromoteRuleShow = true
      this.showRulePopup = true
    },
    // 关闭活动规则
    handleCloseRulePopup() {
      this.showRulePopup = false
    },
    viewAgreement(e) {
      this.$router.push(e)
    },
    // 获取当前时间时间戳（到秒 10位）
    getDataTimeNow() {
      GetDataTimeNow().then((res) => {
        const { code, data } = res
        if (code == '0') {
          let nT = Number('' + `${data}000`)
          this.nowTime = Number('' + `${data}000`)
          // console.log('nT', nT)
          // console.log('this.endPublicityTime', this.endPublicityTime)
          // console.log('----公示时间', nT > this.endPublicityTime)
          if (nT <= this.endPublicityTime) {
            console.log('未到发奖公示时间')
            this.isPublicityTimeEnd = false
          }
          if (nT > this.endPublicityTime) {
            console.log('已到发奖公示时间')
            this.isPublicityTimeEnd = true
          }
        }
      })
    },
    // 活动信息
    getActivityInfo() {
      GetActivityInfo({ activityId: this.activityId }).then((res) => {
        const { code, data } = res
        if (code == '0') {
          document.title = data && data.activityName
          let objs = JSON.parse(JSON.stringify(data || {}))
          for (let k in objs) {
            if (k == 'startTime' || k == 'endTime') {
              objs[k] = objs[k].slice(5, 10).split('-').join('月') + '日'
            }
          }
          // console.log('objs', objs)
          this.activityInfo = objs

          let eT = new Date(data.endTime.replace(/-/g, '/')).getTime() // 活动结束时间戳
          // console.log('eT', eT)
          // console.log('this.nowTime', this.nowTime)
          // console.log('----活动', eT > this.nowTime)
          if (this.nowTime <= eT) {
            console.log('活动未结束')
            this.isActivityEnd = false
          }
          if (this.nowTime > eT) {
            console.log('活动已结束')
            this.isActivityEnd = true
          }

          this.getUserCommissionRankListByTime(data)
        }
      })
    },
    // 通过商品Ids获取商品信息
    getProductListByIds() {
      GetProductListByIds({
        ids: this.ids
      }).then((res) => {
        const { code, data } = res
        if (code == '0') {
          this.productList = data.list || []
        }
      })
    },
    // 排行榜list
    getUserCommissionRankListByTime(params) {
      this.topThree = []
      this.saleRanksList = []
      GetUserCommissionRankListByTime({
        startTime: params.startTime,
        endTime: params.endTime
      }).then((res) => {
        const { code, data } = res
        if (code == '0') {
          this.mySaleRank = data.mySaleRank
          this.mySaleAmount = data.mySaleAmount
          data.saleRanks &&
            data.saleRanks.forEach((item) => {
              if (item.saleAmount > 10000) {
                item.saleAmountShort = (item.saleAmount / 10000).toFixed(2)
              } else {
                item.saleAmountShort = item.saleAmount
              }
            })
          if (data.saleRanks.length > 0) {
            this.topThree = data.saleRanks.slice(0, 3)
            this.saleRanksList = data.saleRanks.slice(3, 20)
          }
          this.loading = false
        } else {
          this.loading = false
        }
      })
    },

    // 生成海报
    shareHandle(item) {
      if (this.isDisable) return
      if (!localStorage.getItem('token')) {
        this.goLogin()
        return
      }
      if (!this.isAuthorized) {
        this.isVisible = true
        return
      }
      setTimeout(() => {
        // 埋点，会员数据上报（点击事件）
        MGTVVIP_click_event(
          `${this.activityInfo.startTime.slice(0, 3)}活动页-${
            item.productName
          }-点击商品分享赚`,
          this.userInfo.mgUuid
        )
      }, 200)
      this.shareProduct = item
      this.showProductPopup = true
    },
    handleClose() {
      this.showProductPopup = false
    },

    goAwardPlacard() {
      this.$router.push({
        path: '/awardPlacard',
        query: {
          activityId: this.activityInfo.id,
          publicityStartDate: this.publicityStartDate,
          publicityEndDate: this.publicityEndDate
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
</style>